// extracted by mini-css-extract-plugin
export default {"confirmMessage":"ConfirmMessage_confirmMessage__vDKIS"};